import React from "react";
import moment from "moment";
import useLaporanFilters, { LaporanTabKey } from "./useLaporanFilters";

type DateFilter = [Date | null, Date | null];

export default function useLaporanViewState() {
    const now = React.useMemo(() => moment().format("YYYY/MM/DD"), []);
    const nowK = React.useMemo(
        () => moment().format("DD MMM YYYY HH:mm:ss"),
        [],
    );
    const today = React.useMemo(() => new Date(), []);

    const { tanggalAwal, tanggalAkhir, dateRange, setDateRange, tabSlug, setTabSlug } =
        useLaporanFilters();

    const [openTooltipTotalPendapatan, setOpenTooltipTotalPendapatan] =
        React.useState(false);
    const [openTooltipTotalTransaksi, setOpenTooltipTotalTransaksi] =
        React.useState(false);
    const [openTooltipProdukTerjual, setOpenTooltipProdukTerjual] =
        React.useState(false);
    const [isOpenModalAlertPro, setIsOpenModalAlertPro] = React.useState(false);
    const [isOpenModalUnduhLaporan, setIsOpenModalUnduhLaporan] =
        React.useState(false);
    const [isOpenModalPrintTutupBuku, setIsOpenModalPrintTutupBuku] =
        React.useState(false);

    const [startDate, endDate] = dateRange;

    const openModalUnduhLaporan = React.useCallback(() => {
        setIsOpenModalUnduhLaporan(true);
    }, []);

    const closeModalUnduhLaporan = React.useCallback(() => {
        setIsOpenModalUnduhLaporan(false);
    }, []);

    const openModalPrintTutupBuku = React.useCallback(() => {
        setIsOpenModalPrintTutupBuku(true);
    }, []);

    const closeModalPrintTutupBuku = React.useCallback(() => {
        setIsOpenModalPrintTutupBuku(false);
    }, []);

    const openModalAlertPro = React.useCallback(() => {
        setIsOpenModalAlertPro(true);
    }, []);

    const closeModalAlertPro = React.useCallback(() => {
        setIsOpenModalAlertPro(false);
    }, []);

    const handleTabChange = React.useCallback(
        (slug: LaporanTabKey) => {
            setTabSlug(slug);
        },
        [setTabSlug],
    );

    const changeTab = React.useCallback(
        (slug: LaporanTabKey) => {
            setTabSlug(slug);
            const tabsContainer = document.getElementById("tabs-container");
            tabsContainer?.scrollIntoView(true);
        },
        [setTabSlug],
    );

    const handleDateRangeChange = React.useCallback(
        (update: DateFilter) => {
            setDateRange(update);
        },
        [setDateRange],
    );

    const toggleTooltipTotalPendapatan = React.useCallback(() => {
        setOpenTooltipTotalPendapatan((prev) => !prev);
    }, []);

    const closeTooltipTotalPendapatan = React.useCallback(() => {
        setOpenTooltipTotalPendapatan(false);
    }, []);

    const toggleTooltipTotalTransaksi = React.useCallback(() => {
        setOpenTooltipTotalTransaksi((prev) => !prev);
    }, []);

    const closeTooltipTotalTransaksi = React.useCallback(() => {
        setOpenTooltipTotalTransaksi(false);
    }, []);

    const toggleTooltipProdukTerjual = React.useCallback(() => {
        setOpenTooltipProdukTerjual((prev) => !prev);
    }, []);

    const closeTooltipProdukTerjual = React.useCallback(() => {
        setOpenTooltipProdukTerjual(false);
    }, []);

    return {
        changeTab,
        closeModalAlertPro,
        closeModalPrintTutupBuku,
        closeModalUnduhLaporan,
        closeTooltipProdukTerjual,
        closeTooltipTotalPendapatan,
        closeTooltipTotalTransaksi,
        dateRange,
        endDate,
        handleDateRangeChange,
        handleTabChange,
        isOpenModalAlertPro,
        isOpenModalPrintTutupBuku,
        isOpenModalUnduhLaporan,
        now,
        nowK,
        openModalAlertPro,
        openModalPrintTutupBuku,
        openModalUnduhLaporan,
        openTooltipProdukTerjual,
        openTooltipTotalPendapatan,
        openTooltipTotalTransaksi,
        startDate,
        tabSlug,
        tanggalAkhir,
        tanggalAwal,
        today,
        toggleTooltipProdukTerjual,
        toggleTooltipTotalPendapatan,
        toggleTooltipTotalTransaksi,
    };
}
